import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../../config/baseWithToken";

export const getSourcingRequests = createAsyncThunk(
  "admin/products/sourcing-request",
  async (product, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/admin/products/sourcing-request?page=${product.page}&size=${50}&text=${
          product.text || ""
        }`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

